export default __webpack_public_path__ + "static/media/empty.b5871f03.png";